/**
 * Created by fijas on 4/17/17.
 */
import {Injectable, inject} from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ProjectSimple} from '../../dash/ProjectSimple';
import {Observable} from 'rxjs';

@Injectable()
export class DashService {

    // URL to web api
    private baseUrl: string = environment.apiBaseUrl;

    private http = inject(HttpClient);

    getFavorites() {
        return this.http.get(this.baseUrl + 'dash/favorites');
    }

    getQueries() {
        return this.http.get(this.baseUrl + 'dash/queries');
    }

    getRecents(): Observable<ProjectSimple[]> {
        return this.http.get<ProjectSimple[]>(this.baseUrl + 'dash/recent-projects');
    }

    getTrendingProjects(): Observable<ProjectSimple[]> {
        return this.http.get<ProjectSimple[]>(this.baseUrl + 'dash/trending-projects');
    }

    getContractorAwarded() {
        return this.http.get(this.baseUrl + 'dash/contractor-awards');
    }

    getProjectsAdded() {
        return this.http.get(this.baseUrl + 'dash/added-projects');
    }

    getCovidProjects() {
        return this.http.get(this.baseUrl + 'dash/covids');
    }

    getRecentMep() {
        return this.http.get(this.baseUrl + 'dash/recent-meps');
    }

    getContractorExpected() {
        return this.http.get(this.baseUrl + 'dash/contractor-expecteds');
    }

    getMepExpected() {
        return this.http.get(this.baseUrl + 'dash/mep-expecteds');
    }

    markWelcomeSeen() {
        return this.http.post(this.baseUrl + 'dash/dashlets/welcome-seen', {});
    }

    closeSantaForm(status) {
        return this.http.post(this.baseUrl + 'dash/santas/close', {status: status});
    }

    saveSecretSanta(formData) {
        return this.http.post(this.baseUrl + 'dash/santas', formData);
    }

    updateDashlets(dashlets: any[]) {
        localStorage.setItem('dashlets', JSON.stringify(dashlets));

        return this.http.patch(this.baseUrl + 'dash/dashlets/1', dashlets);
    }

    agreePrivacy() {
        return this.http.post(this.baseUrl + 'profile/agree-privacy', {});
    }

    getWebinars() {
        const limit = 4;
        return this.http.get(this.baseUrl + 'dash/webinars?limit=' + limit);
    }

    getYoutubeVideos() {
        let headers = new HttpHeaders();
        headers = headers.set('skip-auth', '');

        const apiKey = environment.youTubeKey;
        const channelId = environment.youTubeChannelId;
        const maxResults = 4;
        const youtubeUrl = 'https://www.googleapis.com/youtube/v3/search?key=' + apiKey + '&channelId=' + channelId + '&order=date&part=snippet &type=video,id&maxResults=' + maxResults;
        return this.http.get(youtubeUrl, {headers: headers});
    }

    getTenderTransferLink() {
        return this.http.post(this.baseUrl + 'dash/tenders', {});
    }

    getRecommendedProjects(): Observable<any> {
        return this.http.get<any>(this.baseUrl + 'dash/recommended-projects');
    }
}
